module.exports = __webpack_public_path__ + "static/fipcnavyteddymain-1cef50b7bec14e7cfac3b834364a176c.jpeg";